import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

import { tenantQueryOptions } from '@/shared/auth/session'
import { ErrorState } from '@/shared/components/error-state'
import { NotFound } from '@/shared/components/not-found'
import { RootSkeleton } from '@/shared/layout/root-skeleton'
import { Toaster } from '@/shared/ui/sonner'

export interface RouterContext {
  queryClient: QueryClient
}

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  // Carrega o tenant antes de renderizar para a marca não piscar o fallback.
  // Falha aqui não deve derrubar a tela: o componente cai no t('app.name').
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(tenantQueryOptions).catch(() => undefined)
  },
  // Na carga inicial não há tela anterior a preservar: mostra o skeleton de
  // imediato (sem tempo mínimo) para não deixar a tela vazia.
  pendingComponent: RootSkeleton,
  pendingMs: 0,
  pendingMinMs: 0,
  component: RootComponent,
  notFoundComponent: NotFound,
  errorComponent: ({ error, reset }) => <ErrorState error={error} onRetry={reset} fullPage />,
})

function RootComponent() {
  return (
    <>
      <Outlet />
      <Toaster richColors closeButton position="top-right" />
    </>
  )
}
